import React, { useState } from "react";
import AuthPlainLayout from "./Layout/AuthPlainLayout";
import { AuthContainer } from "./Layout/AdminLayout.styled";
import { Input, Button, Form } from "antd";
import { toast } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { AdminActionLogin } from "../../redux/actions/adminActions";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginCredentialsSchema } from "../validattion";

const AdminLogin = (props) => {
  const [loading, setLoading] = useState(false);
  // const { AdminActionLogin } = props;
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginCredentialsSchema),
  });

  const history = useHistory();

  const performAdminLogin = () => {
    setLoading(true);
    setTimeout(() => {
      toast.success("E shock you! Just Testing Design", {
        pauseOnHover: false,
      });
      history.push("/admin/dashboard");
      setLoading(false);
    }, 1000);
  };

  // const performAdminLogin = async (data, e) => {
  //     setLoading(true);
  //     e.preventDefault();
  //     const res = await AdminActionLogin(data);
  //     if (res.success && res.role === 'admin') {
  //         setLoading(false);
  //         toast.success(res.message, {
  //             pauseOnHover: false,
  //         });
  //         setTimeout(() => {
  //             history.push('/admin/dashboard');
  //             setLoading(false);
  //         }, 1000);
  //     } else if (res.success && res.role !== 'admin') {
  //         toast.warning('Account does not have admin role', {
  //             position: 'top-right',
  //             autoClose: 5000,
  //             hideProgressBar: false,
  //             closeOnClick: true,
  //             pauseOnHover: true,
  //             draggable: true,
  //             progress: undefined,
  //         });
  //         setLoading(false);
  //     } else {
  //         toast.error(res.message, {
  //             position: 'top-right',
  //             autoClose: 5000,
  //             hideProgressBar: false,
  //             closeOnClick: true,
  //             pauseOnHover: true,
  //             draggable: true,
  //             progress: undefined,
  //         });
  //         setLoading(false);
  //     }
  // };

  return (
    <>
      <AuthPlainLayout
        pageTitle="Admin Login"
        title="Welcome Admin!"
        subtitle="Enter your login details"
      >
        <AuthContainer data-aos="fade-down" data-aos-duration="2000">
          <div className="login">
            <Form
              className="login__form"
              autoComplete="off"
              onFinish={handleSubmit(performAdminLogin)}
            >
              <div className="form-group">
                <label>Email</label>
                <Controller
                  name="email"
                  control={control}
                  defaultValue=""
                  render={({ field }) => <Input {...field} />}
                />
                {errors.email && (
                  <span className="error">Email Address is required</span>
                )}
              </div>
              <div className="form-group">
                <label>Password</label>
                <Controller
                  name="password"
                  control={control}
                  defaultValue=""
                  render={({ field }) => <Input {...field} />}
                />
                {errors.password && (
                  <span className="error">Password is required</span>
                )}
              </div>
              <div className="form-group">
                <Button
                  onClick={handleSubmit(performAdminLogin)}
                  loading={loading}
                  type="primary"
                  size="large"
                  htmlType="submit"
                  block
                >
                  {loading ? "Authenticating..." : "Sign In"}
                </Button>
              </div>
            </Form>
          </div>
        </AuthContainer>
      </AuthPlainLayout>
    </>
  );
};

const mapStateToProps = (state) => {
  return state;
};

export default connect(mapStateToProps, { AdminActionLogin })(AdminLogin);
